import { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

import GrowthChartDoctor from "./GrowthChartDoctorView";
import styles from "./PatientProfilePage.module.css";
import CircularLoading from "../loading/Loading.jsx";
import capitalzer from "../util/capitalize.js";

import axios from "axios";
import {
  calculateAgeInMonths,
  caluclateAgeinDays,
  caluclateGestationalAgeInDays,
  getDateAndYear,
  getFormattedDate,
} from "../helper/getAge.js";
import { getTipContent } from "../helper/getTipContent.js";
import {
  ageRange,
  getAgeCategory,
  getAgeCategoryByDays,
  getAgeGroupFromDOB,
} from "../helper/getAgeGroup.js";
import AddVisitForm from "./AddVisitRecordForm.jsx";
import MilestoneTrackerView from "./MilstoneTrackerView.jsx";
import VaccinationTrackerView from "./VaccinationTrackerView.jsx";
import TdscViewer from "./TdscViewer.jsx";
import MchatView from "./MchatView.jsx";
import PastVisitRecordDoctorView from "./PastVisitRecordDoctorView.jsx";
import { toast } from "react-toastify";
import Loader from "./Loader.jsx";
import { useParentContext } from "../context/ParentContext.jsx";
import TdscChartNew from "../components-4-6/TdscChart.jsx";

const PatinetProfilePage = () => {
  const { id, docId } = useParams();
  const token = localStorage.getItem("s2stoken");
  const { language } = useParentContext();

  const [Loading, setLoading] = useState(true);
  const [newLoading, setNewLoading] = useState(false);
  const [patient, setPatient] = useState(null);
  const [caregiver, setCaregiver] = useState(null);
  const [ageGroup, setAgeGroup] = useState(null);
  const [shareAgeGroup, setShareAgeGroup] = useState(null);
  const [selectedTip, setSelectedTip] = useState("Select Tip");
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [popupContent, setPopupContent] = useState("");
  const [selectedHealthData, setSelectedHealthData] = useState("");
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [formattedSummary, setFormattedSummary] = useState("");
  const [currentAge, setCurrentAge] = useState(0);
  const [currentAgeInDays, setCurrentAgeInDays] = useState(0);
  const [gestationalAgeInDays, setGestationalAgeInDays] = useState("");
  const [gestationalAgeInMonths, setGestationalAgeInMonths] = useState("");
  const [sickVisitComplete, setsickVisitComplete] = useState(true);
  const [visitData, setVisitData] = useState(null);
  const [isSickVisit, setIsSickVisit] = useState(false);
  const [isShareMaterial, setIsShareMaterial] = useState(false);
  const backendURL = process.env.REACT_APP_BACKEND_URL;
  // ? fetching initially patient and caregiver info
  useEffect(() => {
    const fetchPatientData = async () => {
      const url = `${backendURL}/api/get_patient_fully_details/${id}/${docId}`;
      setLoading(true);
      try {
        const patientData = await axios.get(url, {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setPatient(patientData.data.patient);
        setCaregiver(patientData.data.caregiver);

        const patientAgeGroup = getAgeGroupFromDOB(
          patientData?.data?.patient?.date_of_birth
        );

        setAgeGroup(patientAgeGroup);
        setCurrentAge(
          calculateAgeInMonths(patientData?.data?.patient?.date_of_birth)
        );
        // setCurrentAge(calculateAgeInMonths(getFormattedDate(patientData?.data?.patient?.date_of_birth)))
        setCurrentAgeInDays(
          caluclateAgeinDays(patientData?.data?.patient?.date_of_birth)
        );
        const actualAge = caluclateAgeinDays(
          patientData?.data?.patient?.date_of_birth
        );
        const actualAgeInMonths = calculateAgeInMonths(
          patientData?.data?.patient?.date_of_birth
        );
        const gestationalAgeInDays = caluclateGestationalAgeInDays(
          patientData?.data?.patient?.date_of_birth,
          patientData?.data?.patient?.edd
        );
        if (patientData?.data?.patient?.edd) {
          const eddAgeIndays = caluclateAgeinDays(
            patientData?.data?.patient?.edd
          );
          const diffWeeks = eddAgeIndays
            ? Math.round((eddAgeIndays - actualAge) / 7)
            : "";
          const gestWeeks = 40 + diffWeeks;
          const gestMonthsDiff = Math.floor((40 - gestWeeks) / 4);
          const gestMonths = actualAgeInMonths - gestMonthsDiff;
          const gestationalAgeDays =
            getDateAndYear(patientData?.data?.patient?.date_of_birth) ===
            getDateAndYear(patientData?.data?.patient?.edd)
              ? actualAge
              : gestationalAgeInDays !== 0
              ? actualAge - gestationalAgeInDays
              : 0;
          if (gestWeeks < 37) {
            setGestationalAgeInDays(`${gestationalAgeDays} Days`);
            setGestationalAgeInMonths(gestMonths);
          } else {
            setGestationalAgeInDays(`${actualAge} Days`);
            setGestationalAgeInMonths(actualAgeInMonths);
          }
        } else if (
          !patientData?.data?.patient?.edd &&
          patientData?.data?.patient?.gestational_age
        ) {
          const adjustedAgeDays =
            actualAge -
            Math.round((40 - patientData?.data?.patient?.gestational_age) * 7);
          const gestMonthDiff = Math.floor(
            (40 - Number(patientData?.data?.patient?.gestational_age)) / 4
          );
          console.log("gestMonthDiff", gestMonthDiff);
          const adjustedAgeMonths = actualAgeInMonths - gestMonthDiff;
          if (patientData?.data?.patient?.gestational_age < 37) {
            setGestationalAgeInMonths(adjustedAgeMonths);
            setGestationalAgeInDays(`${adjustedAgeDays} Days`);
          } else {
            setGestationalAgeInDays(`${actualAge} Days`);
            setGestationalAgeInMonths(actualAgeInMonths);
          }
        } else {
          setGestationalAgeInDays(0);
          setGestationalAgeInMonths(0);
        }

        const summaryArray =
          patientData?.data?.patient?.ai_health_summary
            ?.split("\n")
            .filter((line) => line.trim() !== "")
            .map((line, index) => {
              const shouldNotTranslate =
                line.trim().startsWith("Name") ||
                line.trim().startsWith("Patient Name");
              return (
                <p
                  key={index}
                  {...(shouldNotTranslate ? { translate: "no" } : {})}
                >
                  {line}
                </p>
              );
            }) || [];

        setFormattedSummary(
          summaryArray.length > 0
            ? summaryArray
            : [<p>Health Summary is not available</p>]
        );
      } catch (error) {
        if (error?.response?.data?.message === "Token has expired") {
          localStorage.removeItem("s2stoken");
          navigate("/");
        }
        console.log("Error while fetching patient data : ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPatientData();
  }, [id, docId, sickVisitComplete]);

  console.log(patient);
  console.log(gestationalAgeInMonths);
  //! Handle Clicks
  const healthDataRef = useRef(null);
  useEffect(() => {
    if (visitData !== null && isSickVisit) {
      setIsFormVisible(true);
    } else if (visitData) {
      handleWellnessChange();
    }
    setSelectedHealthData("");
  }, [visitData]);

  const closePopup = () => {
    setIsPopupVisible(false);
    setSelectedTip("Select Tip");
  };

  const handleAgeAppropirateChange = (e) => {
    const selected = e.target.value;
    setSelectedTip(selected);

    // Show the popup with the selected tip content
    if (selected !== "Select Tip") {
      setPopupContent(getTipContent(selected, ageGroup));
      setIsPopupVisible(true);
    }
  };
  const handleShareAgeGroup = (e) => {
    const selected = e.target.value;
    setShareAgeGroup(selected);
    if (!selected) {
      return setIsShareMaterial(false);
    }
    setIsShareMaterial(true);
  };

  async function handleShareMaterial() {
    if (!shareAgeGroup) return;
    const payload = {
      patientId: patient?.patient_id,
      ageGroup: shareAgeGroup,
    };
    try {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setNewLoading(true);
      const res = await axios.patch(`${backendURL}/api/share_docs`, payload, {
        withCredentials: true,
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(res.data);
      if (res?.data?.status === "success") {
        setNewLoading(false);
        setsickVisitComplete(!sickVisitComplete);
        toast.success("Material shared with parent");
      }
    } catch (error) {
      if (error?.response?.data?.message === "Token has expired") {
        localStorage.removeItem("s2stoken");
        navigate("/");
      }
      setNewLoading(false);
      toast.error("Failed to share material");
      console.log("error in share material", error);
    }
  }

  const handleHealthDataChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedHealthData(selectedValue);
  };

  useEffect(() => {
    setSelectedHealthData("");
  }, [language]);
  useEffect(() => {
    if (selectedHealthData && healthDataRef.current) {
      healthDataRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [selectedHealthData]);

  const navigate = useNavigate();

  const handleWellnessChange = () => {
    if (visitData !== null) {
      const newGestationalAgeDays =
        Number(visitData?.gestational_age_in_days) === 0
          ? 0
          : `${visitData?.gestational_age_in_days} Days`;
      const newAgeGroup =
        visitData?.patient_age_in_months === 0
          ? getAgeCategoryByDays(visitData?.age_days)
          : getAgeCategory(visitData?.patient_age_in_months);
      return navigate(
        `/new-add-visit-record/${patient?.patient_id}/${docId}/${newAgeGroup}/${visitData?.patient_age_in_months}/${visitData?.age_days}/${visitData?.gestational_age_in_months}/${newGestationalAgeDays}`,
        {
          state: {
            patient: patient,
            visitData: visitData,
          },
        }
      );
    }
    navigate(
      `/new-add-visit-record/${patient?.patient_id}/${docId}/${ageGroup}/${currentAge}/${currentAgeInDays}/${gestationalAgeInMonths}/${gestationalAgeInDays}`,
      {
        state: {
          patient: patient,
          visitData: visitData,
        },
      }
    );
  };

  const handleUpdatePatientProfileChange = () => {
    navigate(`/update-patient/${patient?.patient_id}/${docId}`);
  };

  if (Loading) {
    return <CircularLoading />;
  }

  return (
    <div className={styles.patientContainer}>
      <Loader isLoading={newLoading} />
      <div className={styles.innerContainer}>
        <div className={styles.header}>
          <div
            className={styles.backButton}
            onClick={() => navigate("/pediatrician-dashboard")}
          >
            <FontAwesomeIcon className="icon" icon={faArrowLeft} />
            <span>Back to Dashboard</span>
          </div>
          <h1 className={styles.heading}>Patient Profile</h1>
          <button onClick={handleUpdatePatientProfileChange}>
            Update Patient
          </button>
        </div>
        <div className={styles.patientProfile}>
          <div>
            <label>First Name</label>
            <span className="notranslate" translate="no">
              {capitalzer(patient?.first_name)}
            </span>
          </div>
          <div>
            <label>Last Name</label>
            <span className="notranslate" translate="no">
              {capitalzer(patient?.last_name)}
            </span>
          </div>
          <div>
            <label>Caregiver First Name</label>
            <span className="notranslate" translate="no">
              {capitalzer(caregiver?.first_name)}
            </span>
          </div>
          <div>
            <label>Caregiver Last Name</label>
            <span className="notranslate" translate="no">
              {capitalzer(caregiver?.last_name)}
            </span>
          </div>
          <div>
            <label>Actual Age</label>
            <span className={styles.date} translate="no">
              {calculateAgeInMonths(patient?.date_of_birth) === 0
                ? `${caluclateAgeinDays(patient?.date_of_birth)} Days `
                : `${calculateAgeInMonths(patient?.date_of_birth)} Months`}
            </span>
          </div>
          {currentAge <= 24 && (
            <div>
              <label>Adjusted Age</label>
              <span className={styles.date} translate="no">
                {gestationalAgeInDays !== 0
                  ? gestationalAgeInMonths === 0
                    ? gestationalAgeInDays
                    : gestationalAgeInMonths + " Months"
                  : "N/A"}
              </span>
            </div>
          )}
        </div>

        <div className={styles.tipsection}>
          <div>
            <label htmlFor="ageAppropriateTips">Age Appropriate Tips </label>
            <select
              id="age-tips-dropdown"
              value={selectedTip}
              onChange={handleAgeAppropirateChange}
            >
              <option value="Select Tip">Select Tip</option>
              <option value="Development">Development</option>
              <option value="GoodHealth">Good Health</option>
              <option value="Nutrition">Nutrition</option>
              <option value="Security-Safety">Safety & Security</option>
              <option value="Responsive-Caregiving">
                Responsive Caregiving
              </option>
              <option value="Oppertunity-for-Early-Learning">
                Opportunity for Early Learning
              </option>
              <option value="Red-Flags">Red Flags</option>
            </select>
          </div>
          <div className={styles.buttonDiv}>
            <label htmlFor="share-material">Educational Material</label>
            <div className={styles.shareMaterial}>
              <select
                id="share-material"
                value={shareAgeGroup}
                onChange={handleShareAgeGroup}
              >
                <option value="">Select Age Group</option>
                {Object.keys(ageRange).map((item, i) => {
                  return (
                    <option key={i} value={item}>
                      {item === patient?.age_group
                        ? `${ageRange[item]}   [shared]`
                        : ageRange[item]}
                    </option>
                  );
                })}
              </select>
              {isShareMaterial && (
                <button type="button" onClick={handleShareMaterial}>
                  Share
                </button>
              )}
            </div>
          </div>
          <div className={styles.buttonDiv}>
            <button onClick={handleWellnessChange}>Wellness Visit</button>

            <button
              onClick={() => {
                setIsFormVisible(true);
              }}
            >
              Sick Visit
            </button>
          </div>
        </div>

        {isPopupVisible && (
          <div className={styles.ageAppropriateOverlay}>
            <div className={styles.ageAppropriateContainer}>
              <div className={styles.ageAppropriateContaint}>
                <h3>{selectedTip}</h3>
                <div>
                  <h2>Ask</h2>
                  <p>{popupContent.Ask}</p>
                </div>
                <div>
                  <h2>Assess</h2>
                  <p>{popupContent.Assess}</p>
                </div>
                <div>
                  <h2>Do</h2>
                  <p>{popupContent.Do}</p>
                </div>
                <div>
                  <h2>Counsel</h2>
                  <p>{popupContent.Counsel}</p>
                </div>

                <button
                  onClick={closePopup}
                  className={styles.closePopupButton}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        {isFormVisible && (
          <AddVisitForm
            onClose={() => {
              setIsFormVisible(false);
              setIsSickVisit(false);
              setVisitData(null);
            }}
            pediatricianId={docId}
            patientId={id}
            currentAge={currentAge}
            ageInDays={currentAgeInDays}
            gestationalAgeInDays={gestationalAgeInDays}
            gestationalAgeInMonths={gestationalAgeInMonths}
            setsickVisitComplete={setsickVisitComplete}
            sickVisitComplete={sickVisitComplete}
            visitData={visitData}
          />
        )}

        <section className={styles.profileSection}>
          <header>Patient Health Summary</header>
          <div>{formattedSummary}</div>
        </section>
        <div className={styles.healthData}>
          <label htmlFor="healthData">View Health Data</label>
          <select
            id="healthData"
            value={selectedHealthData}
            onChange={handleHealthDataChange}
          >
            <option value="">Select Data</option>
            <option value="past_visit_records">All Visit Records</option>
            <option value="growth_charts">Growth Charts</option>
            <option value="immunizations">Vaccination Tracker</option>
            <option value="mtwredflags">Milestone Tracker & Red Flags</option>
            <option value="tdscChart">TDSC Chart</option>
            <option value="mchat">M-CHAT</option>
          </select>
        </div>

        {selectedHealthData && (
          <div ref={healthDataRef} className={styles.healthDataContainer}>
            <div className={styles.healthDataContent}>
              {selectedHealthData === "mtwredflags" && (
                <MilestoneTrackerView patientId={id} pediatricianId={docId} />
              )}
              {selectedHealthData === "immunizations" && (
                <VaccinationTrackerView patientId={id} pediatricianId={docId} />
              )}
              {selectedHealthData === "growth_charts" && (
                <GrowthChartDoctor childId={id} />
              )}
              {selectedHealthData === "tdscChart" &&
                (currentAge <= 36 ? (
                  <TdscViewer
                    patientId={id}
                    pediatricianId={docId}
                    currentAge={currentAge}
                  />
                ) : (
                  <TdscChartNew
                    patientId={id}
                    pediatricianId={docId}
                    currentAge={currentAge}
                  />
                ))}
              {selectedHealthData === "mchat" && (
                <MchatView id={id} docId={docId} />
              )}
              {selectedHealthData === "past_visit_records" && (
                <PastVisitRecordDoctorView
                  id={id}
                  docId={docId}
                  patientName={`${patient.first_name} ${patient.last_name}`}
                  currentAge={currentAge}
                  setVisitData={setVisitData}
                  setIsSickVisit={setIsSickVisit}
                />
              )}
            </div>
          </div>
        )}

        <div className={styles.topCircle}></div>
        <div className={styles.bottomCircle}></div>
      </div>
    </div>
  );
};

export default PatinetProfilePage;
